import JSONAPIAdapter from '@ember-data/adapter/json-api';
import config from 'admin-panel/config/environment';
import { computed } from '@ember/object'; // eslint-disable-line ember/no-computed-properties-in-native-classes
import { service } from '@ember/service';

import type SessionService from 'ember-simple-auth/services/session';
import type ModelRegistry from 'ember-data/types/registries/model'; // eslint-disable-line ember/use-ember-data-rfc-395-imports

const {
  charlotte: { host, namespace },
} = config;

export default class CharlotteTranslationAdapter extends JSONAPIAdapter {
  host = host;
  namespace = namespace;

  @service
  declare session: SessionService;

  @computed('session.{data.authenticated.access_token,isAuthenticated}')
  get headers() {
    const headers: Record<string, string> = {};

    if (this.session.isAuthenticated && this.session.data.authenticated) {
      const { auth_token: authToken, client_id: clientId } =
        this.session.data.authenticated;

      headers['Authorization'] = `Token ${authToken};client_id=${clientId}`;
    }

    return headers;
  }

  pathForType(modelName: keyof ModelRegistry) {
    const charlotte = (modelName as string).match(/^charlotte\/(.+?)$/);

    return super.pathForType((charlotte && charlotte[1]) || modelName);
  }

  handleResponse(...args: Parameters<JSONAPIAdapter['handleResponse']>) {
    this.ensureResponseAuthorized(args[0]);

    return super.handleResponse(...args);
  }

  ensureResponseAuthorized(status: number) {
    if (status === 401 && this.session.isAuthenticated) {
      this.session.invalidate();
    }
  }
}

declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'charlotte/translation': CharlotteTranslationAdapter;
  }
}
